var $body = $("body");
$body.on("mouseover", ".megamenu_style_6 .tab-left .menu-lv-2", function (e) {
  var $target = $(this),
    dataActive = $target.attr("data-active");

  if ($target.find(".sub-menu-mobile").length > 0) {
    e.preventDefault();
    e.stopPropagation();
  }
  $(".megamenu_style_6 .tab-left .menu-lv-2").removeClass("is-active");
  $(this).addClass("is-active");
  $(".megamenu_style_6 .tab-right").removeClass("is-active");
  $(`.megamenu_style_6 .tab-right[data-active='${dataActive}']`).addClass(
    "is-active"
  );
});

if (window.innerWidth <= 1024) {
  $body.on("click", ".megamenu_style_6 .tab-left .menu-lv-2", function (e) {
    var $target = $(this);

    if ($(this).hasClass("is-active-mb")) {
      $(this).removeClass("is-active-mb");
    } else {
      $(".megamenu_style_6 .tab-left .menu-lv-2").removeClass("is-active-mb");

      $(this).addClass("is-active-mb");
    }
  });
}
